'use strict';

import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import StoreClass from 'Store';
import { Fields, System } from 'Constants/objects';
import { Model } from "Model";
import { formEditSubmited } from 'Actions/Forms/FormEditActions';
import { showSnackBar } from 'Actions/D5SnackbarsActions';
import { formDestroyed, formSubmit } from 'Actions/Forms/FormActions';
import { topBarSetTitle } from 'Actions/TopBarActions';
import { changeDocumentTitle } from 'Actions/ApplicationActions';
import { d5TableFilterSaved, d5TableFocusRowAfterFormEdit, d5TableUpdateFilterSubForm } from 'Actions/Table/D5TableActions';
import { tbSetReadOnlyMode } from "Actions/Table/TableToolBarActions";
import { formEditCustomAction } from 'UserActionHandler/UserScriptActions';
import { Messages } from 'Messages';
import { createGuid, createTableComponentID, formatDateToAPI, formatMessage, formatNumberPrecision, getAddFilter, getLSTableCols, getShowRowFilter, isEmptyObject, setAddSSFilter, setShowRowSSFilter, setSSTableCols, getSSTableCols, getAddSSFilter, itemWithIconTemplate, getControlDXType, isLookup, isEmptyValue } from 'D5Utils/functions';
import { sharedData } from 'SharedData';
import { loadAppObjectsCollection, loadButtons, loadFilterFields, loadFormButtonEvents, loadFormFields, loadFormGroups, loadFormMetadata, loadSubForms, loadFormDecorationElements, loadUserFunctions } from 'D5Utils/common_requests';
import { createEditUrl } from 'Router';
import ReactDOM from 'react-dom';
import Columns from 'Stores/Table/core/table/Columns';
import Configurator from 'Stores/Table/core/table/Configurator';
import { Collection } from "Collection";
import { CustomLoader } from 'D5Utils/CustomLoader';
import { UserScriptModel } from 'UserActionHandler/UserScriptModel';
import { UserScriptCriticalError } from "UserActionHandler/UserScriptErrors";
import { FormItemsBuilder } from "Stores/Forms/FormItemsBuilder";
import BaseControl from "D5Utils/form_fields/BaseControl";
var CHANGE_EVENT = 'change';

var FormEditStore =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(FormEditStore, _StoreClass);

  function FormEditStore() {
    var _getPrototypeOf2;

    var _this2;

    _classCallCheck(this, FormEditStore);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormEditStore)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "formID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "rowID", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "type", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "initialized", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "title", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "name", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "objectName", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "fieldData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "fieldGroupsData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "decorationElements", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "formFieldsData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "formEditInstance", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "popupInst", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "mode", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "viewMode", System.VIEW_MODE.MODAL);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "detailsData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "formEvents", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "userEvents", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "updating", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "additionalData", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "modified", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "formUUID", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "insideFormInstances", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "keyField", '');

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "nestedFields", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "requestDefaultColumns", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "buttonEvents", []);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "saving", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "isVisibleForm", true);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "isReadOnlyForm", false);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "nestedForms", new Map());

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "loader", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "editors", new Map());

    return _this2;
  }

  _createClass(FormEditStore, [{
    key: "initialize",
    value: function initialize(options) {
      var _this3 = this;

      var formUUID = options.formUUID,
          additionalData = options.additionalData,
          parentTitle = options.parentTitle,
          formObj = options.formObj,
          instances = options.instances,
          disablingButtons = options.disablingButtons;
      this.formUUID = formUUID;
      this.additionalData = additionalData;
      this.parentTitle = parentTitle;
      this.parentUUID = formObj.parentUUID;
      this.formID = Number(formObj.formID);
      this.rowID = formObj.rowID;
      this.mode = formObj.mode;
      this.viewMode = formObj.viewMode;
      this.formEditInstance = instances.form;
      this.popupInst = instances.popup;
      this.scrollView = instances.scrollView;
      this.disablingButtons = disablingButtons;
      var _System$GROUP_TYPE = System.GROUP_TYPE,
          PANEL = _System$GROUP_TYPE.PANEL,
          TAB_PANEL = _System$GROUP_TYPE.TAB_PANEL,
          TAB = _System$GROUP_TYPE.TAB,
          ACCORDION = _System$GROUP_TYPE.ACCORDION;
      Promise.all([loadFormMetadata(this.formID), loadButtons({
        formID: this.formID,
        position: System.BUTTON_POSITION.IN_GROUP
      }), loadFormGroups({
        formID: this.formID,
        groupType: [PANEL, TAB_PANEL, TAB, ACCORDION]
      }), loadSubForms(this.formID), loadFormDecorationElements(this.formID), loadFilterFields(this.formID)]).then(function (values) {
        var metadata = values[0];
        var buttons = values[1];
        var groups = values[2];
        var details = values[3];
        var decorationElements = values[4];
        var filtersFields = values[5];
        _this3.title = metadata[Fields.Title];
        _this3.name = metadata[Fields.Name];
        _this3.objectName = metadata[Fields.ObjectID_Name];
        _this3.type = metadata[Fields.Type];
        _this3.keyField = metadata[Fields.ObjectID_KeyObjectFieldID_Name];
        _this3.fieldGroupsData = groups;
        _this3.decorationElements = decorationElements;
        _this3.formDetailsData = details;
        _this3.filtersFields = filtersFields;

        if (_this3.mode === System.FORM_EDIT_CREATE_MODE.ADD) {
          _this3.setModified();
        }

        var subFormIDs = details.map(function (item) {
          return item[Fields.DetailFormID];
        }); // fields - index 0

        var promises = [loadFormFields([_this3.formID].concat(_toConsumableArray(subFormIDs)))]; // buttonEvents - index 1

        if (buttons.length) {
          promises.push(loadFormButtonEvents(buttons.map(function (b) {
            return b[Fields.ID];
          })));
        }

        Promise.all(promises).then(function (data) {
          var formFields = data[0];
          _this3.buttonEvents = data[1];

          var fieldsByFormID = _.groupBy(formFields, Fields.FormID);

          var fields = _this3.initLookupFields(fieldsByFormID[_this3.formID]);

          _this3.fieldData = _this3.mergeButtonsAndFields(buttons, fields);

          _this3.mergeDecorationAndFields();

          _this3.mergeRequestColumnsWithDetails();

          var ids = Object.keys(_.groupBy(fields, Fields.ID));
          _this3.formDetailsData = details.map(function (item) {
            var tableFields = _this3.fieldsFromTable(fieldsByFormID[item[Fields.DetailFormID]]);

            if (item[Fields.NestedFieldID_Name] != null) {
              _this3.nestedFields.push(item[Fields.NestedFieldID_Name]);
            }

            return _objectSpread({}, item, {
              viewSource: tableFields,
              requestColumns: _this3.requestTableColumns(tableFields, item[Fields.FormID_ObjectID_KeyObjectFieldID_Name])
            });
          });
          Promise.all([loadUserFunctions(ids), _this3.loadFieldsData(_this3.rowID)]).then(function (data) {
            _this3.userEvents = data[0];
            _this3.formFieldsData = data[1];
            formEditCustomAction(_this3.name, 'formInit', _this3.formFieldsData, _this3.fieldData, _this3.formUUID, {
              rowKeys: _this3.rowID,
              formOperation: _this3.formOperation(),
              isReadOnlyForm: _this3.isReadOnlyForm
            });

            _this3.setFormTitle();
          });
        });
      });
    }
  }, {
    key: "formOperation",
    value: function formOperation() {
      return this.mode === System.FORM_EDIT_CREATE_MODE.ADD ? 'Ins' : 'Mod';
    }
    /**
     * @param {array} fields
     * @return {array}
     */

  }, {
    key: "fieldsFromTable",
    value: function fieldsFromTable() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var systemFields = [];
      var lookupFields = fields.map(function (field) {
        if (field[Fields.ObjectFieldID_LinkedObjectID]) {
          var _objectSpread2;

          if (!field[Fields.DisplayField]) {
            field[Fields.DisplayField] = field[Fields.ObjectFieldID_DisplayObjectFieldID_Name];
          } // KeyFilterField - ключевое поле объекта, например CountryID


          field[Fields.KeyFilterField] = field[Fields.ObjectFieldID_Name]; // ObjectFieldID_Name - полное название с точкой, например CountryID.Name

          field[Fields.ObjectFieldID_Name] += '.' + field[Fields.DisplayField];
          field[Fields.ObjectFieldID_FieldType] = field[Fields.ObjectFieldID_DisplayObjectFieldID_FieldType];
          systemFields.push(_objectSpread({}, field, (_objectSpread2 = {}, _defineProperty(_objectSpread2, Fields.Name, System.SYSTEM_PREFIX + field[Fields.Name]), _defineProperty(_objectSpread2, Fields.IsVisible, 0), _objectSpread2)));
        }

        return field;
      });
      return [].concat(_toConsumableArray(lookupFields), systemFields);
    }
  }, {
    key: "requestTableColumns",
    value: function requestTableColumns(fields, keyField) {
      // определение колонок для отправки на сервер
      // в исходный массив колонок попадают дублирующиеся записи, нужно исправить...
      var requestColumns = [];
      fields.forEach(function (item) {
        if (Columns.isSystemField(item)) {
          return;
        }

        if (item[Fields.KeyFilterField]) {
          requestColumns.push(item[Fields.KeyFilterField]);
        }

        if (item[Fields.ObjectFieldID_Name]) {
          requestColumns.push(item[Fields.ObjectFieldID_Name]);
        }
      });
      requestColumns.push(keyField);
      return requestColumns;
    }
    /**
     * @return {*|Map<any, any>|Map<string, string>}
     */

  }, {
    key: "getList",
    value: function getList() {
      return {
        initialized: this.initialized,
        detailsData: this.detailsData,
        isReadOnlyForm: this.isReadOnlyForm
      };
    }
    /**
     * @param {array} fields
     * @return {Array}
     */

  }, {
    key: "fillDisplayFields",
    value: function fillDisplayFields(fields) {
      return fields.map(function (item) {
        if (isLookup(item) && !item[Fields.DisplayField]) {
          item[Fields.DisplayField] = item[Fields.ObjectFieldID_DisplayObjectFieldID_Name];
        }

        return item;
      });
    }
    /**
     * @param {array} fields
     * @return {Array}
     */

  }, {
    key: "initLookupFields",
    value: function initLookupFields() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var lookupFields = this.fillDisplayFields(fields).map(function (field) {
        if (isLookup(field)) {
          // KeyFilterField - ключевое поле объекта, например CountryID
          field[Fields.KeyFilterField] = field[Fields.ObjectFieldID_Name]; // ObjectFieldID_Name - полное название с точкой, например CountryID.Name

          field[Fields.ObjectFieldID_Name] += '.' + field[Fields.DisplayField];
          field[Fields.ObjectFieldID_FieldType] = field[Fields.ObjectFieldID_DisplayObjectFieldID_FieldType];
        }

        return field;
      });
      this.setRequestColumns(lookupFields);
      return lookupFields;
    }
  }, {
    key: "setRequestColumns",
    value: function setRequestColumns(formFieldsData) {
      var _this4 = this;

      // определение колонок для отправки на сервер
      // в исходный массив колонок попадают дублирующиеся записи, нужно исправить...
      var dataColumns = {};

      _.each(formFieldsData, function (item) {
        dataColumns[item[Fields.ID]] = _objectSpread({}, item);
      });

      dataColumns = _.sortBy(dataColumns, Fields.Order);
      var requestColumns = [];
      dataColumns.forEach(function (item) {
        if (item[Fields.KeyFilterField]) {
          requestColumns.push(item[Fields.KeyFilterField]);
        }

        if (item[Fields.ObjectFieldID_Name]) {
          requestColumns.push(item[Fields.ObjectFieldID_Name]);
        }

        if (item[Fields.Name]) {
          _this4.requestDefaultColumns.push(item[Fields.Name]);
        }
      });
      this.requestColumns = requestColumns;
    }
  }, {
    key: "navigateToParent",
    value: function navigateToParent() {
      sharedData.lastRowIndex = null;

      if (this.viewMode === System.VIEW_MODE.FULL_SCREEN && this.mode === System.FORM_EDIT_CREATE_MODE.EDIT) {
        sharedData.lastRowIndex = this.rowID;
      }

      this.unmountDetailComponent();
      d5TableFocusRowAfterFormEdit({
        focusID: this.rowID
      });
      formDestroyed(this.formUUID);
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var message = this.getValidationFormData();

      if (message) {
        return Promise.reject(new Error(message));
      }

      return Promise.resolve();
    }
  }, {
    key: "innerValidate",
    value: function innerValidate(instance) {
      try {
        var validation = DevExpress.validationEngine.validateGroup(instance);
        return validation ? validation.brokenRules : [];
      } catch (e) {
        return [];
      }
    }
  }, {
    key: "instance",
    value: function instance() {
      return this.formEditInstance.dxForm('instance');
    }
  }, {
    key: "getValidationFormData",
    value: function getValidationFormData() {
      var _this5 = this;

      var isValid = _toConsumableArray(this.innerValidate(this.instance()));

      _.each(this.insideFormInstances, function (form) {
        isValid = [].concat(_toConsumableArray(isValid), _toConsumableArray(_this5.innerValidate(form)));
      });

      return isValid.map(function (item) {
        return item.message;
      }).join('<br/>');
    }
  }, {
    key: "confirmSave",
    value: function confirmSave() {
      if (!this.modified) {
        return Promise.resolve();
      }

      return DevExpress.ui.dialog.custom({
        message: Messages.Confirm.SaveChanges,
        title: Messages.Controls.Confirmation,
        buttons: [{
          text: Messages.Controls.Yes,
          onClick: function onClick() {
            return true;
          }
        }, {
          text: Messages.Controls.No,
          onClick: function onClick() {
            return false;
          }
        }, {
          text: Messages.Controls.Cancel,
          onClick: function onClick() {
            return null;
          }
        }]
      }).show();
    }
  }, {
    key: "checkCloseWindow",
    value: function checkCloseWindow(msg) {
      var close = false;

      try {
        close = window.opener && window.opener.document.location.origin === document.location.origin;
        window.addEventListener('unload', function () {
          if (close && typeof window.D5.afterChildClose === 'function') {
            window.D5.afterChildClose(msg);
          }
        });

        if (close) {
          window.close();
        }
      } catch (e) {
        close = false;
      }

      return close;
    }
  }, {
    key: "childTableDataToSource",
    value: function childTableDataToSource(_ref) {
      var selector = _ref.selector,
          viewSource = _ref.viewSource,
          formType = _ref.formType,
          _ref$data = _ref.data,
          data = _ref$data === void 0 ? [] : _ref$data;
      var dxType = formType === System.FORM_TYPE.LIST ? 'dxDataGrid' : 'dxTreeList';
      var ins = $(selector)[dxType]('instance');
      var items = data.length ? data : ins.option('dataSource');
      var keyField = ins.option('keyExpr').substring(System.SYSTEM_PREFIX.length);
      return items.map(function (row) {
        var tableData = Configurator.columnDataToSourceData({
          data: row,
          viewSource: viewSource,
          instance: ins
        }); // если ключевое поле null то это скорее всего добавленная новая запись,
        // а при добавлении нам ключевое поле не нужно

        if (tableData[keyField] == null) {
          delete tableData[keyField];
        }

        return tableData;
      });
    }
  }, {
    key: "nestedFieldsForSave",
    value: function nestedFieldsForSave() {
      var _this6 = this;

      var result = {};
      this.formDetailsData.forEach(function (detail) {
        var formID = detail[Fields.DetailFormID];
        var formType = detail[Fields.DetailFormID_Type];
        var parentFormID = detail[Fields.FormID];
        var nsField = detail[Fields.NestedFieldID_Name];

        if (nsField) {
          result[nsField] = _this6.childTableDataToSource({
            selector: "#".concat(createTableComponentID(formID, parentFormID, formType)),
            viewSource: detail.viewSource,
            formType: formType
          });
        }
      });
      return result;
    }
  }, {
    key: "formDataForSave",
    value: function formDataForSave() {
      var result = _objectSpread({}, this.prepareFormData(), this.nestedFieldsForSave());

      if (this.mode === System.FORM_EDIT_CREATE_MODE.ADD) {
        delete result[this.keyField];
      }

      return result;
    }
  }, {
    key: "submitForm",
    value: function submitForm(applyMode) {
      var _this7 = this;

      var that = this;
      var _System$FORM_EDIT_CRE = System.FORM_EDIT_CREATE_MODE,
          ADD = _System$FORM_EDIT_CRE.ADD,
          MULTI_EDIT = _System$FORM_EDIT_CRE.MULTI_EDIT,
          EDIT = _System$FORM_EDIT_CRE.EDIT;

      if (this.saving) {
        return Promise.resolve();
      }

      this.saving = true;
      return this.validateForm().then(function () {
        var formData = _this7.formDataForSave();

        return new Promise(function (resolve) {
          var ObjectModel = Model.extend({
            initialize: function initialize() {
              this.object = that.objectName;
            },
            idAttribute: _this7.keyField
          });
          var model = new ObjectModel();

          if (_this7.mode === ADD) {
            model.save(formData, {
              success: function success(model) {
                _this7.rowID = model.get(_this7.keyField);

                if (!applyMode) {
                  _this7.afterSaveModel(ADD, applyMode, _this7.rowID);

                  resolve(formData);
                } else {
                  _this7.afterSaveModel(ADD, applyMode, _this7.rowID).then(function () {
                    resolve(formData);
                  });
                }

                that.saving = false;
              },
              error: function error(model, response) {
                that.saving = false;
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: response.ResponseText
                });
              }
            });
          } else if (_this7.mode === MULTI_EDIT) {
            var objectCollection = _this7.createObjectCollection(formData);

            objectCollection.sync('update', objectCollection, {
              success: function success() {
                _this7.afterSaveModel(EDIT, applyMode);

                that.saving = false;
                resolve(formData);
              },
              error: function error(response) {
                that.saving = false;
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: response.ResponseText
                });
              }
            });
          } else {
            model.save(_objectSpread({}, formData, _defineProperty({}, _this7.keyField, _this7.rowID)), {
              success: function success() {
                _this7.afterSaveModel(EDIT, applyMode);

                that.saving = false;
                resolve(formData);
              },
              error: function error(model, response) {
                that.saving = false;
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: response.ResponseText
                });
              }
            });
          }
        });
      }).catch(function (error) {
        if (error.message) {
          that.saving = false;
          showSnackBar({
            type: System.SNACKBAR_TYPES.Error,
            message: error.message
          });
        }
      });
    }
  }, {
    key: "afterSaveModel",
    value: function afterSaveModel(mode, applyMode, id) {
      var _this8 = this;

      showSnackBar({
        type: System.SNACKBAR_TYPES.Success,
        message: Messages.Success.Saved
      });

      if (this.modified && applyMode) {
        this.title = this.title.trim().slice(0, -1);
        topBarSetTitle(this.title);
        changeDocumentTitle(this.title);
      }

      this.modified = false;

      if (applyMode && mode === System.FORM_EDIT_CREATE_MODE.ADD) {
        var route = location.hash.match(/^#subsystem\/(\d+)/);
        this.mode = System.FORM_EDIT_CREATE_MODE.EDIT;
        var url = createEditUrl({
          parentRoute: route[0],
          mode: this.mode,
          formID: this.formID,
          id: id
        });
        this.rowID = id;
        history.pushState({}, null, url);
        return new Promise(function (resolve) {
          _this8.loadFieldsData(_this8.rowID).then(function (fieldData) {
            d5TableUpdateFilterSubForm(_this8.formUUID, fieldData);
            resolve();
          });
        });
      }

      if (!this.checkCloseWindow(Messages.Success.Saved) && !applyMode) {
        this.navigateToParent();
      }
    }
  }, {
    key: "renderFieldGroups",
    value: function renderFieldGroups() {
      var _this9 = this;

      var groups = [];

      var isDetailFormGroup = function isDetailFormGroup(group) {
        return _this9.formDetailsData.some(function (detail) {
          return detail[Fields.GroupID] === group[Fields.ID];
        });
      };

      _.each(this.fieldGroupsData, function (item) {
        var group = {};
        group['itemType'] = 'group';
        group[Fields.ID] = item[Fields.ID];
        group[Fields.ParentGroupID] = item[Fields.ParentGroupID];
        group[Fields.Order] = item[Fields.Order];
        group[Fields.IsVisible] = item[Fields.IsVisible];
        group[Fields.Orientation] = item[Fields.Orientation];
        group[Fields.GroupType] = item[Fields.GroupType];
        group[Fields.IsCollapsed] = item[Fields.IsCollapsed];
        group['colCount'] = item[Fields.Orientation];
        group['items'] = [];
        group['visible'] = Boolean(item[Fields.IsVisible]);
        group[Fields.Icon] = item[Fields.Icon];

        if (item[Fields.Title] && item[Fields.IsShowTitle]) {
          group['caption'] = item[Fields.Title];
        } else {
          group['cssClass'] = 'form-no-padding';
          group[Fields.Title] = item[Fields.Title];
        }

        if (isDetailFormGroup(item)) {
          group['cssClass'] = 'form-no-padding';
        }

        groups.push(group);
      });

      this.groupsDetails(groups);
      this.setFormFieldsData();
      this.showForm(groups);
    }
  }, {
    key: "nestedFormLoaded",
    value: function nestedFormLoaded(_ref2) {
      var UUID = _ref2.UUID;
      this.nestedForms.set(UUID, true);
      var needRepaint = true;
      this.nestedForms.forEach(function (value) {
        if (!value) needRepaint = false;
      });
      if (needRepaint && this.popupInst && this.popupInst.data().hasOwnProperty('dxPopup')) $(this.popupInst).dxPopup('repaint');
      if (needRepaint && this.formEvents && typeof this.formEvents.onFormReady === 'function') this.handleFormReady();
    }
  }, {
    key: "groupsDetails",
    value: function groupsDetails(arrayGroups) {
      var _this10 = this;

      var orderValues = [];
      this.detailsData = [];

      _.each(this.formDetailsData, function (obj) {
        orderValues.push(obj[Fields.Order]);
      });

      var firstElement = _.find(this.formDetailsData, function (obj) {
        return obj[Fields.Order] === _.min(orderValues);
      });

      _.each(this.formDetailsData, function (item) {
        var _arrayGroups$push;

        var UUID = createGuid();

        _this10.nestedForms.set(UUID, false);

        arrayGroups.push((_arrayGroups$push = {
          itemType: 'group',
          cssClass: 'detail-form'
        }, _defineProperty(_arrayGroups$push, Fields.ParentGroupID, item[Fields.GroupID]), _defineProperty(_arrayGroups$push, Fields.Order, item[Fields.Order]), _defineProperty(_arrayGroups$push, Fields.ID, "sub-form-".concat(item[Fields.ID])), _defineProperty(_arrayGroups$push, Fields.IsVisible, 1), _defineProperty(_arrayGroups$push, "template", function template(data, itemElement) {
          $("<div class='detail-form-cont' id='detail-formedit-".concat(item[Fields.DetailFormID], "'></div>")).appendTo(itemElement);
        }), _arrayGroups$push));

        _this10.detailsData.push({
          id: "detail-formedit-".concat(item[Fields.DetailFormID]),
          formID: item[Fields.DetailFormID],
          formType: item[Fields.DetailFormID_Type],
          parentFormID: item[Fields.FormID],
          masterObjKeyFieldName: item[Fields.MasterObjectFieldID_Name],
          detailObjKeyFieldName: item[Fields.DetailObjectFieldID_Name],
          filtersData: _defineProperty({}, item[Fields.DetailObjectFieldID_Name], _this10.formFieldsData[item[Fields.MasterObjectFieldID_Name]]),
          isFocus: item[Fields.ID] === firstElement[Fields.ID] ? true : null,
          viewSource: item.viewSource,
          requestColumns: item.requestColumns,
          owner: _this10,
          UUID: UUID,
          tableData: item[Fields.NestedFieldID_Name] ? _this10.formFieldsData[item[Fields.NestedFieldID_Name]] || [] : null
        });
      });

      this.detailsData.forEach(function (sub) {
        if (sub.formType === System.FORM_TYPE.LIST || sub.formType === System.FORM_TYPE.TREE) {
          var lsName = createTableComponentID(sub.formID, sub.parentFormID, sub.formType);
          setSSTableCols(lsName, getLSTableCols(lsName));
          setAddSSFilter(lsName, getAddFilter(lsName));
          setShowRowSSFilter(lsName, getShowRowFilter(lsName));
        }
      });
    }
  }, {
    key: "receiveNestedData",
    value: function receiveNestedData(_ref3) {
      var data = _ref3.data,
          subFormID = _ref3.subFormID,
          respKey = _ref3.respKey,
          _ref3$needRepaint = _ref3.needRepaint,
          needRepaint = _ref3$needRepaint === void 0 ? true : _ref3$needRepaint;
      var detailObj = this.formDetailsData.find(function (detail) {
        return detail[Fields.DetailFormID] === subFormID;
      });
      var detailComponent = this.detailsData.find(function (detail) {
        return detail.formID === subFormID;
      });
      var nsField = detailObj[Fields.NestedFieldID_Name];
      this.formFieldsData[nsField] = data;
      detailComponent.tableData = data;

      if (needRepaint) {
        this.emit(CHANGE_EVENT);
      }
    } // данные формы без lookup полей

  }, {
    key: "setFormFieldsData",
    value: function setFormFieldsData() {
      var _this11 = this;

      this.objectDefaultData = {};
      this.requestDefaultColumns.map(function (item) {
        _this11.objectDefaultData[item] = _this11.getValueByFieldName(item);
      });

      _.each(this.additionalData, function (value, key) {
        var fields = _.filter(_this11.fieldData, function (item) {
          return item[Fields.ObjectFieldID_Name] === key || item[Fields.KeyFilterField] === key;
        });

        _.each(fields, function (field) {
          field[Fields.IsReadOnly] = 1;
          _this11.objectDefaultData[field.Name] = value;
        });
      });

      if (this.mode === System.FORM_EDIT_CREATE_MODE.ADD) {
        var ls = "".concat(this.formID, "-parentfield");
        var parentObj = JSON.parse(sessionStorage.getItem(ls) || '{}');
        this.objectDefaultData = _objectSpread({}, this.objectDefaultData, parentObj);
        sessionStorage.removeItem(ls);
      }
    }
  }, {
    key: "getFieldByName",
    value: function getFieldByName(name) {
      return _.find(this.fieldData, function (item) {
        return item.Name === name;
      });
    }
  }, {
    key: "getValueByFieldName",
    value: function getValueByFieldName(fieldName) {
      var field = this.getFieldByName(fieldName);

      if (field) {
        var value = isLookup(field) ? this.formFieldsData[field[Fields.KeyFilterField]] : this.formFieldsData[field[Fields.ObjectFieldID_Name]];

        switch (getControlDXType(field)) {
          case System.DX_CONTROLS.dxCheckBox:
            return Boolean(value);

          case System.DX_CONTROLS.dxDateBox:
            return value;

          case System.DX_CONTROLS.dxNumberBox:
            return formatNumberPrecision(value, field[Fields.ObjectFieldID_NumberPrecision]);

          default:
            return value;
        }
      }
    }
  }, {
    key: "buildItems",
    value: function buildItems(groups) {
      this.itemsBuilder = new FormItemsBuilder({
        formFields: this.fieldData,
        formData: this.objectDefaultData,
        objectName: this.objectName,
        formEdit: this,
        groups: groups
      });
      return this.itemsBuilder.build();
    }
  }, {
    key: "showForm",
    value: function showForm(groups) {
      var _this12 = this;

      this.formEditInstance = $(this.formEditInstance).dxForm({
        formData: this.objectDefaultData,
        items: this.buildItems(groups),
        tabIndex: -1,
        onInitialized: function onInitialized(e) {
          if (typeof _this12.formEvents.onInitialized === 'function') _this12.checkFormErrors();
        },
        onEditorEnterKey: function onEditorEnterKey(e) {
          if (e.event.ctrlKey && e.event.keyCode === 13) {
            // Ctrl+Enter
            e.component.getEditor(e.dataField).blur(); // для того чтобы обновилось значение поля

            formSubmit(_this12.formUUID);
          }
        },
        onContentReady: function onContentReady(_ref4) {
          var component = _ref4.component,
              element = _ref4.element;
          // таймаут потому что форма загружается раньше чем показывается попап, взято из примера поддержки либы
          setTimeout(function () {
            _this12.loader = new CustomLoader({
              loaderSelector: "#edit-form-loader-".concat(_this12.formID),
              nodeSelector: "#".concat($(_this12.formEditInstance).attr('id'))
            });
            var $elements = element.find('input,select,textarea');
            $("#fe-title-".concat(_this12.formUUID)).html(_this12.title);
            /**
             * Adding icon to the group title
             * https://teamtrack.macc.com.ua/view.php?id=0059695
             * */

            _.each(_this12.fieldGroupsData, function (field) {
              if (field[Fields.Icon] && field[Fields.GroupType] !== System.GROUP_TYPE.TABLE_HEADER) {
                var groupTitleSelector = '.dx-form-group-caption';

                if (field[Fields.GroupType] === System.GROUP_TYPE.ACCORDION) {
                  groupTitleSelector = '.dx-accordion-item-title';
                }

                var $currentGroup = $(".fe-group-id_".concat(field[Fields.ID]));
                var groupTitleBlock = $currentGroup.find(groupTitleSelector)[0];

                if (groupTitleBlock) {
                  var text = groupTitleBlock ? $(groupTitleBlock).text() : '';
                  var template = itemWithIconTemplate({
                    text: text,
                    type: System.TEMPLATE_TYPE.TITLE,
                    icon: field[Fields.Icon],
                    titleType: field[Fields.TitleType]
                  });
                  $(groupTitleBlock).html(template);
                }
              }
            });

            for (var i = 0; i < $elements.length; ++i) {
              var editor = component.getEditor($elements[i].name);

              if (editor && !editor.option('disabled') && editor.option('visible')) {
                editor.focus();
                break;
              }
            }

            function labelClick(e) {
              var input = $("#".concat($(e.currentTarget).attr('for')));
              input.trigger('focus');
              input.trigger('select');
            }

            var $labels = $('.dx-field-item-label');
            $labels.off('click', labelClick);
            $labels.on('click', labelClick);
            if (_this12.isVisibleForm) _this12.initialized = true;
            sharedData.formEditProcessed = null;

            _this12.emit(CHANGE_EVENT);
          }, 600);
        },
        onDisposing: function onDisposing(e) {
          if (typeof _this12.formEvents.onDisposing === 'function') {
            _this12.formEvents.onDisposing(e);
          }
        }
      });

      if (this.popupInst && this.isVisibleForm) {
        if (this.viewMode === System.VIEW_MODE.MODAL && this.detailsData.length) {
          this.popupInst.dxPopup('option', 'maxHeight', '90%');
        }

        this.popupInst.dxPopup('show');
      }
    }
  }, {
    key: "createFromData",
    value: function createFromData(data, view) {
      var formData = {};

      _.each(view, function (field) {
        if (field[Fields.ObjectFieldID_FieldType] !== 'button') {
          var df = isLookup(field) ? field[Fields.KeyFilterField] : field[Fields.ObjectFieldID_Name];
          formData[field.Name] = data[df];
        }
      });

      return formData;
    }
  }, {
    key: "prepareFormData",
    value: function prepareFormData() {
      var _this13 = this;

      var formData = this.getFormData();
      /* На форме formData хранит названия полей FormFields.Name.
         * Для запроса нужно обратно переписать на соответствующие поля.
         * */

      var preparedFormData = {};

      _.each(formData, function (value, key) {
        var field = _this13.getFieldByName(key);

        if (!field) {
          return;
        }

        var df = isLookup(field) ? field[Fields.KeyFilterField] : field[Fields.ObjectFieldID_Name];

        switch (_typeof(value)) {
          case 'boolean':
            preparedFormData[df] = Number(value);
            break;

          case 'string':
            var dataType = getControlDXType(field);
            preparedFormData[df] = value;

            if (dataType === System.DX_CONTROLS.dxDateBox) {
              preparedFormData[df] = formatDateToAPI(new Date(value), field[Fields.ObjectFieldID_IsTimeAllowed]);
            }

            break;

          case 'number':
            if (field[Fields.ObjectFieldID_NumberScale] != null) {
              preparedFormData[df] = Number(Number.parseFloat(value).toFixed(field[Fields.ObjectFieldID_NumberScale]));
            } else {
              preparedFormData[df] = value;
            }

            break;

          default:
            preparedFormData[df] = value;
        }
      });

      preparedFormData = _objectSpread({}, preparedFormData, _defineProperty({}, this.keyField, this.rowID), this.additionalData || {});
      return preparedFormData;
    }
  }, {
    key: "getFormData",
    value: function getFormData() {
      var formData = this.instance().option('formData');

      _.each(this.insideFormInstances, function (form) {
        var _ref5;

        var insideFormFields = _.pluck(form.option('items'), 'dataField');

        var insideFormData = (_ref5 = _).pick.apply(_ref5, [form.option('formData')].concat(_toConsumableArray(insideFormFields)));

        formData = _objectSpread({}, formData, insideFormData);
      });

      return formData;
    }
  }, {
    key: "getEventNameByField",
    value: function getEventNameByField(fieldID, eventType) {
      var uEvents = this.userEvents;
      var fieldEvent = uEvents && uEvents.find(function (e) {
        return e[Fields.FormFieldID] === Number(fieldID) && e[Fields.EventTypeID] === eventType;
      });

      if (fieldEvent && fieldEvent[Fields.FunctionName]) {
        return fieldEvent[Fields.FunctionName];
      }
    }
  }, {
    key: "formHasTable",
    value: function formHasTable(name) {
      return this.formDetailsData.some(function (detail) {
        if (detail[Fields.DetailFormID_Name] === name) return detail[Fields.DetailFormID_Name];
      });
    }
  }, {
    key: "getUSTableObj",
    value: function getUSTableObj(detail) {
      var getFieldByName = function getFieldByName(_ref6) {
        var fieldName = _ref6.fieldName,
            viewSource = _ref6.viewSource;
        return _.find(viewSource, function (item) {
          return item[Fields.Name] === fieldName;
        });
      };

      var formID = detail[Fields.DetailFormID];
      var formType = detail[Fields.DetailFormID_Type];
      var parentFormID = detail[Fields.FormID];
      var formName = detail[Fields.DetailFormID_Name];
      var nsField = detail[Fields.NestedFieldID_Name];
      var dxType = formType === System.FORM_TYPE.LIST ? 'dxDataGrid' : 'dxTreeList';

      if (nsField) {
        var ins = $("#".concat(createTableComponentID(formID, parentFormID, formType)))[dxType]('instance'); // FIXME https://teamtrack.macc.com.ua/view.php?id=59639 - убрать костыль

        if (ins && ins.getDataSource()) {
          var items = ins.option('dataSource');
          var tableFormUUID = ins.option('formUUID');
          var data = items.map(function (row) {
            var rowData = _objectSpread({}, row);

            for (var name in rowData) {
              if (rowData.hasOwnProperty(name)) {
                var field = getFieldByName({
                  viewSource: detail.viewSource,
                  fieldName: name
                });

                if (field && isLookup(field) && name.indexOf(System.SYSTEM_PREFIX) !== 0) {
                  rowData[name] = rowData[System.SYSTEM_PREFIX + name];
                }
              }
            }

            return rowData;
          });
          return {
            parentForm: this.name,
            columns: detail.viewSource,
            keyField: detail[Fields.FormID_ObjectID_KeyObjectFieldID_Name],
            isNested: true,
            formID: formID,
            parentFormID: parentFormID,
            tableFormUUID: tableFormUUID,
            data: data,
            formName: formName,
            formType: formType,
            filter: {
              formFields: detail.viewSource,
              viewSource: this.filtersFields,
              lsColumns: getSSTableCols(this.getLSName(formID, parentFormID, formType)),
              addFilter: getAddSSFilter(this.getLSName(formID, parentFormID, formType))
            }
          };
        }
      }
    }
  }, {
    key: "getTableByName",
    value: function getTableByName(name) {
      var detail = this.formDetailsData.find(function (detail) {
        return detail[Fields.DetailFormID_Name] === name;
      });
      return this.getUSTableObj(detail);
    }
  }, {
    key: "getTablesDataToUserScript",
    value: function getTablesDataToUserScript() {
      var _this14 = this;

      var tables = {};
      this.formDetailsData.forEach(function (detail) {
        var formName = detail[Fields.DetailFormID_Name];
        tables[formName] = _this14.getUSTableObj(detail);
      });
      return tables;
    }
  }, {
    key: "getLSName",
    value: function getLSName(formID, parentFormID, formType) {
      return createTableComponentID(formID, parentFormID, formType);
    }
  }, {
    key: "emitUserEvent",
    value: function emitUserEvent(fieldID, eventType) {
      if (this.updating) {
        return;
      }

      var formData = this.prepareFormData();
      var tables = this.getTablesDataToUserScript();
      var eventName = this.getEventNameByField(fieldID, eventType);

      if (eventName) {
        this.updating = eventName;
        this.loader.show();
        formEditCustomAction(this.name, eventName, formData, this.fieldData, this.formUUID, {
          owner: this,
          formOperation: this.formOperation(),
          tables: tables
        });
      }
    }
  }, {
    key: "loadFieldsData",
    value: function loadFieldsData(rowID) {
      if (!rowID || Array.isArray(rowID)) return Promise.resolve([]);
      var formModel = Model.extend({
        object: this.objectName
      });
      var requestBody = {
        Columns: this.requestColumns,
        NestedColumns: {},
        Filters: _defineProperty({}, this.keyField, rowID)
      };

      for (var i = 0; i < this.formDetailsData.length; ++i) {
        var subForm = this.formDetailsData[i];

        if (subForm[Fields.NestedFieldID_Name]) {
          var nsName = subForm[Fields.NestedFieldID_Name];
          requestBody.NestedColumns[nsName] = {
            Columns: subForm.requestColumns,
            Page: -1
          };
        }
      }

      return new Promise(function (resolve) {
        new formModel().fetch({
          data: requestBody,
          success: function success(formFieldsData) {
            resolve(formFieldsData.toJSON());
          },
          error: function error(model, response) {
            resolve({});
            showSnackBar({
              type: System.SNACKBAR_TYPES.Error,
              message: formatMessage(Messages.Errors.ErrorWhileRequest, [response.ResponseText])
            });
          }
        });
      });
    }
  }, {
    key: "mergeRequestColumnsWithDetails",
    value: function mergeRequestColumnsWithDetails() {
      // извлекаем название полей поле из объекта главной формы. Значение которых будет использоваться для фильтрации подчиненных списков.
      // записываем их в массив колонок для запроса получения данных
      var details = this.formDetailsData.filter(function (det) {
        return det[Fields.MasterObjectFieldID_Name];
      }).map(function (det) {
        return det[Fields.MasterObjectFieldID_Name];
      });
      this.requestColumns = _toConsumableArray(new Set([].concat(_toConsumableArray(details), _toConsumableArray(this.requestColumns))));
    }
  }, {
    key: "mergeButtonsAndFields",
    value: function mergeButtonsAndFields(buttons, fields) {
      var out = buttons.map(function (item) {
        item[Fields.ObjectFieldID_FieldType] = System.FIELD_TYPE.BUTTON;
        item[Fields.IsVisible] = true;
        return _objectSpread({}, item);
      });

      if (out.length) {
        out = _.sortBy([].concat(_toConsumableArray(fields), _toConsumableArray(out)), Fields.Order);
        return out;
      } else {
        return fields;
      }
    }
  }, {
    key: "mergeDecorationAndFields",
    value: function mergeDecorationAndFields() {
      var out = this.decorationElements.map(function (item) {
        item[Fields.ObjectFieldID_FieldType] = System.FIELD_TYPE.DECORATION;
        return _objectSpread({}, item);
      });

      if (out.length) {
        this.fieldData = _.sortBy([].concat(_toConsumableArray(this.fieldData), _toConsumableArray(out)), Fields.Order);
      }
    }
  }, {
    key: "initForm",
    value: function initForm() {
      var _this15 = this;

      this.onEditorPreparing().then(function (newView) {
        if (newView) {
          _this15.fieldData = _this15.fieldData.map(function (fd) {
            var field = newView.find(function (nView) {
              return nView.ID === fd.ID;
            });

            if (field) {
              return field;
            }

            return fd;
          });
        }

        _this15.renderFieldGroups();
      });
    }
  }, {
    key: "processEditorPreparing",
    value: function () {
      var _processEditorPreparing = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(newViews) {
        var viewsNames, loaded, obj, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, view;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /*это значит что в пользовательском скрипте задали новый ObjectFieldID_LinkedObjectID_Name
                * в таком случае зануляется ObjectFieldID_LinkedObjectID и его нужно отдельно запросить
                * */
                viewsNames = newViews.filter(function (v) {
                  return v[Fields.ObjectFieldID_LinkedObjectID] == null && v[Fields.ObjectFieldID_LinkedObjectID_Name] != null;
                }).map(function (v) {
                  return v[Fields.ObjectFieldID_LinkedObjectID_Name];
                });

                if (viewsNames.length) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", newViews);

              case 3:
                _context.next = 5;
                return loadAppObjectsCollection({
                  Name: viewsNames
                });

              case 5:
                loaded = _context.sent;
                obj = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;

                for (_iterator = loaded[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  view = _step.value;
                  obj[view.Name] = view;
                }

                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 18:
                _context.prev = 18;
                _context.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 21:
                _context.prev = 21;

                if (!_didIteratorError) {
                  _context.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context.finish(21);

              case 25:
                return _context.finish(18);

              case 26:
                return _context.abrupt("return", newViews.map(function (v) {
                  var name = v[Fields.ObjectFieldID_LinkedObjectID_Name];

                  if (obj.hasOwnProperty(name)) {
                    v[Fields.ObjectFieldID_LinkedObjectID] = obj[name][Fields.ID];
                    v[Fields.DisplayField] = obj[name][Fields.DisplayObjectFieldID_Name];
                    v[Fields.ObjectFieldID_KeyObjectFieldID_Name] = obj[name][Fields.KeyObjectFieldID_Name];
                  }

                  return v;
                }));

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 14, 18, 26], [19,, 21, 25]]);
      }));

      function processEditorPreparing(_x) {
        return _processEditorPreparing.apply(this, arguments);
      }

      return processEditorPreparing;
    }()
  }, {
    key: "onEditorPreparing",
    value: function () {
      var _onEditorPreparing = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var eventName, model, views;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eventName = 'onEditorPreparing';
                _context2.next = 3;
                return this.asyncUserScript({
                  eventName: eventName
                });

              case 3:
                model = _context2.sent;

                if (model) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", this.fieldData);

              case 6:
                views = model.getSourceView();
                _context2.next = 9;
                return this.processEditorPreparing(views);

              case 9:
                return _context2.abrupt("return", _context2.sent);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onEditorPreparing() {
        return _onEditorPreparing.apply(this, arguments);
      }

      return onEditorPreparing;
    }()
    /**
     * @param {Object} tables
     */

  }, {
    key: "updateForm",
    value: function updateForm(_ref7) {
      var _this16 = this;

      var _ref7$tables = _ref7.tables,
          tables = _ref7$tables === void 0 ? {} : _ref7$tables;
      var lastTable = Object.keys(tables)[Object.keys(tables).length - 1];
      this.setFormData(this.instance());

      _.each(this.insideFormInstances, function (form) {
        _this16.setFormData(form.instance());
      });

      for (var tableName in tables) {
        tables[tableName].islastTable = lastTable === tableName;
        this.prepareTableFilters(tables[tableName]);
      }
    }
  }, {
    key: "formEditUpdateSubForm",
    value: function formEditUpdateSubForm(table) {
      !isEmptyObject(table) && this.receiveNestedData({
        data: this.childTableDataToSource({
          selector: "#".concat(createTableComponentID(table.formID, this.formID, table.formType)),
          viewSource: table.columns,
          formType: table.formType,
          data: table.data
        }),
        subFormID: table.formID // needRepaint: false

      });

      if (table && table.islastTable) {
        this.emit(CHANGE_EVENT);
      }
    }
  }, {
    key: "prepareTableFilters",
    value: function prepareTableFilters(table) {
      if (table.filter && table.filter.isChanged) {
        var _table$filter$filter = table.filter.filter,
            lsColumns = _table$filter$filter.lsColumns,
            addFilter = _table$filter$filter.addFilter;
        this.saveFilter(lsColumns, addFilter, table);
      } else {
        this.formEditUpdateSubForm(table);
      }
    }
  }, {
    key: "saveFilter",
    value: function saveFilter(lsColumns, addFilter, table) {
      var lsKey = this.getLSName(table.formID, table.parentFormID, table.formType);
      lsColumns.forEach(function (col) {
        if (isEmptyValue(col.filterValue)) delete col.filterValue;
      });
      setSSTableCols(lsKey, lsColumns);
      setAddSSFilter(lsKey, addFilter);
      d5TableFilterSaved({
        table: table,
        formUUID: table.tableFormUUID,
        formEditUUID: this.formUUID,
        sender: System.FILTER_SENDERS.FORM_EDIT
      });
    }
  }, {
    key: "setFormData",
    value: function setFormData(instance) {
      var _this17 = this;

      var formData = this.createFromData(this.formFieldsData, this.fieldData);

      _.each(formData, function (value, key) {
        var view = _this17.getFieldByName(key);

        if (view) {
          var editor = _this17.editors.get(key);

          if (editor instanceof BaseControl) {
            // set field filter for select
            if (editor.dataSource) {
              var curFlt = editor.dataSource.filter();

              if (view._filter != curFlt) {
                editor.dataSource.filter(view._filter); // нужно для того чтобы обновить выпадающий список

                editor.dataSource.reload();
              }
            }

            if (editor.disabled != view[Fields.IsReadOnly]) {
              editor.disabled = Boolean(view[Fields.IsReadOnly]);
            }

            if (editor.visible != view[Fields.IsVisible]) {
              editor.visible = Boolean(view[Fields.IsVisible]);
            }

            if (editor.getValue() != value) {
              editor.setValue(value);
            }
          }
        }
      });

      instance.option('formData', formData);
    }
  }, {
    key: "setModified",
    value: function setModified() {
      if (!this.modified) {
        this.modified = true;

        if (this.viewMode === System.VIEW_MODE.FULL_SCREEN) {
          this.title += '*';
          topBarSetTitle(this.title);
        } else {
          this.title += '<div style="font-size:15px;display:inline-block;position:relative;top:-4px;">*</div>';
          $("#fe-title-".concat(this.formUUID)).html(this.title);
        }

        changeDocumentTitle(this.title);
      }
    }
  }, {
    key: "cancelForm",
    value: function cancelForm() {
      if (this.checkCloseWindow(Messages.Success.Rejected)) {
        return;
      }

      if (this && this.viewMode === System.VIEW_MODE.MODAL) {
        this.popupInst.dxPopup('hide');
      }

      this.navigateToParent();
    }
  }, {
    key: "createTitle",
    value: function createTitle() {
      var displayField = _.find(this.fieldData, function (field) {
        return field[Fields.ObjectFieldID_IsDisplayField] === 1;
      });

      var value = displayField && this.formFieldsData[displayField[Fields.ObjectFieldID_Name]];
      this.title = "".concat(this.title, " ").concat(value && '-' || '', " ").concat(value || '');
      return this.title;
    }
  }, {
    key: "setFormTitle",
    value: function setFormTitle() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var title = value || this.createTitle();

      if (this.viewMode === System.VIEW_MODE.FULL_SCREEN) {
        topBarSetTitle(title);
      } else {
        $("#fe-title-".concat(this.formUUID)).html(title);
      }

      changeDocumentTitle(title);
    }
  }, {
    key: "unmountDetailComponent",
    value: function unmountDetailComponent() {
      _.each(this.detailsData, function (item) {
        var el = document.getElementById(item.id);
        if (el) ReactDOM.unmountComponentAtNode(el);
      });
    }
  }, {
    key: "formEditUpdate",
    value: function formEditUpdate(options) {
      var _this18 = this;

      this.fieldData = this.copyView(options.nextView);
      this.formFieldsData = _objectSpread({}, options.nextData);
      this.formEvents = _objectSpread({}, options.formEvents);
      this.setReadOnlyFormMode(options.props.isReadOnlyForm);

      if (options.errorMessage) {
        showSnackBar({
          type: System.SNACKBAR_TYPES.Error,
          message: options.errorMessage
        });
      }

      if (this.isChangeConfigControls) this.disablingButtons(options.props.isReadOnlyForm);

      if ($(this.formEditInstance).data('dxForm')) {
        this.processEditorPreparing(this.fieldData).then(function (newView) {
          _this18.fieldData = _this18.copyView(newView);

          _this18.updateForm(_objectSpread({}, options.props));

          _this18.changeFormSettings();

          _this18.redrawChangedControls();

          _this18.resetUpdatingMode();
        });
      } else {
        this.initForm(_objectSpread({}, options.props));
        this.resetUpdatingMode();
      }
    }
  }, {
    key: "redrawChangedControls",
    value: function redrawChangedControls() {
      var _this19 = this;

      this.itemsBuilder.formFields = this.fieldData;
      this.fieldData.filter(function (view) {
        return view[System._Changed];
      }).forEach(function (view) {
        view[System._Changed] = false;

        _this19.itemsBuilder.redrawControl(view.Name);
      });
    }
  }, {
    key: "copyView",
    value: function copyView(views) {
      return views.map(function (view) {
        return _objectSpread({}, view);
      });
    }
  }, {
    key: "setReadOnlyFormMode",
    value: function setReadOnlyFormMode(mode) {
      this.isChangeConfigControls = this.isReadOnlyForm !== mode;
      this.isReadOnlyForm = mode;
    }
  }, {
    key: "changeFormSettings",
    value: function changeFormSettings() {
      if (this.isChangeConfigControls) {
        this.changeConfigControls();
        tbSetReadOnlyMode(this.formUUID, this.isReadOnlyForm);
      }
    }
  }, {
    key: "changeConfigControls",
    value: function changeConfigControls() {
      var _this20 = this;

      if (this.isChangeConfigControls) {
        this.fieldData.forEach(function (view) {
          getControlDXType(view) === System.DX_CONTROLS.dxButton ? _this20.itemsBuilder.changeConfigButton(view.Name, _this20.isReadOnlyForm) : _this20.itemsBuilder.changeConfigControl(view.Name, _this20.isReadOnlyForm);
        });
      }
    }
  }, {
    key: "navigateToParentAction",
    value: function navigateToParentAction() {
      var _this21 = this;

      if (this.modified) {
        this.confirmSave().then(function (result) {
          if (result) {
            _this21.submitForm().then(function (data) {
              if (data) {
                _this21.parentUUID && formEditSubmited({
                  data: data,
                  formUUID: _this21.parentUUID,
                  mode: _this21.mode
                });

                _this21.setFormTitle(_this21.parentTitle);
              }
            });
          } else if (result === false) {
            _this21.cancelForm();
          } else {
            _this21.resetUpdatingMode();
          }
        });
      } else {
        this.cancelForm();
      }
    }
    /**
     * @param {object} formData
     */

  }, {
    key: "createObjectCollection",
    value: function createObjectCollection(formData) {
      var _this22 = this;

      var _this = this;

      var ObjectModel = Model.extend({
        initialize: function initialize() {
          this.object = _this.objectName;
        },
        idAttribute: this.keyField
      });
      var collFields = [];

      _.each(this.rowID, function (id) {
        collFields.push(_objectSpread({}, formData, _defineProperty({}, _this22.keyField, Number(id))));
      });

      var models = collFields.map(function (data) {
        return new ObjectModel(data);
      });
      var coll = new Collection(models);
      coll.model = ObjectModel;
      coll.object = this.objectName;
      return coll;
    }
    /**
     * Calls user defined OnClick event
     * @param {String} eventName
     * @return {Promise<Boolean>} Returns `true` if the next function should be prevented.
     */

  }, {
    key: "buttonUserEvent",
    value: function buttonUserEvent(_ref8) {
      var _this23 = this;

      var eventName = _ref8.eventName;

      if (window[this.name] && typeof window[this.name][eventName] === 'function') {
        var formData = this.prepareFormData();
        var tables = this.getTablesDataToUserScript();
        var props = {
          owner: this,
          formOperation: this.formOperation(),
          tables: tables //isReadOnlyForm: this.isReadOnlyForm

        };
        var formModel = new UserScriptModel(this.fieldData, formData, props, System.USER_SCRIPTS_INITIATOR.FORM_EDIT);
        this.updating = eventName;
        this.loader.show();
        return new Promise(function (resolve) {
          try {
            formModel = window[_this23.name][eventName](formModel);

            if (formModel instanceof Promise) {
              formModel.then(function (model) {
                _this23.formEditUpdate({
                  nextData: model.getSourceData(),
                  nextView: model.getSourceView(),
                  props: model.getProps(),
                  formEvents: _objectSpread({}, model.formEvents),
                  funcName: eventName
                });

                resolve(false);
              }).catch(function (e) {
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: e.message
                });

                _this23.resetUpdatingMode();

                resolve(true);
              });
            } else {
              _this23.formEditUpdate({
                nextData: formModel.getSourceData(),
                nextView: formModel.getSourceView(),
                props: formModel.getProps(),
                formEvents: _objectSpread({}, formModel.formEvents),
                funcName: eventName
              });

              resolve(false);
            }
          } catch (e) {
            showSnackBar({
              type: System.SNACKBAR_TYPES.Error,
              message: e.message
            });

            _this23.resetUpdatingMode();

            resolve(true);
          }
        });
      } else {
        return Promise.resolve(false);
      }
    }
  }, {
    key: "resetUpdatingMode",
    value: function resetUpdatingMode() {
      this.updating = false;
      this.loader && this.loader.hide();
    }
  }, {
    key: "createFormModel",
    value: function createFormModel() {
      var props = {
        owner: this,
        formOperation: this.formOperation(),
        rowKeys: this.rowID,
        isReadOnlyForm: this.isReadOnlyForm
      };
      return new UserScriptModel(this.fieldData, this.objectDefaultData, props, System.USER_SCRIPTS_INITIATOR.FORM_EDIT);
    }
  }, {
    key: "checkFormErrors",
    value: function checkFormErrors() {
      var formModel = this.createFormModel();

      try {
        this.formEvents.onInitialized(formModel);
      } catch (e) {
        if (e instanceof UserScriptCriticalError) {
          showSnackBar({
            type: System.SNACKBAR_TYPES.Error,
            message: e.message
          });
          this.isVisibleForm = false;
          this.navigateToParent();
        }
      }
    }
    /**
     * @param eventName
     * @return {Promise<UserScriptModel | Boolean>}
     */

  }, {
    key: "asyncUserScript",
    value: function () {
      var _asyncUserScript = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(_ref9) {
        var eventName, formModel, newModel;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                eventName = _ref9.eventName;
                formModel = this.createFormModel();
                _context3.prev = 2;

                if (!(typeof this.formEvents[eventName] !== "function")) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", false);

              case 5:
                newModel = this.formEvents[eventName](formModel);

                if (!(newModel instanceof Promise)) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return newModel;

              case 9:
                return _context3.abrupt("return", _context3.sent);

              case 12:
                return _context3.abrupt("return", newModel);

              case 13:
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](2);
                showSnackBar({
                  type: System.SNACKBAR_TYPES.Error,
                  message: _context3.t0.message
                });
                return _context3.abrupt("return", false);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 15]]);
      }));

      function asyncUserScript(_x2) {
        return _asyncUserScript.apply(this, arguments);
      }

      return asyncUserScript;
    }()
  }, {
    key: "handleFormReady",
    value: function handleFormReady() {
      var _this24 = this;

      var eventName = 'onFormReady';
      this.asyncUserScript({
        eventName: eventName
      }).then(function (newModel) {
        if (!newModel) {
          return;
        }

        _this24.formEditUpdate({
          nextData: newModel.getSourceData(),
          nextView: newModel.getSourceView(),
          props: _objectSpread({}, newModel.getProps(), {
            tables: newModel.getTables()
          }),
          formEvents: _objectSpread({}, newModel.formEvents),
          funcName: eventName
        });
      });
    }
  }]);

  return FormEditStore;
}(StoreClass);

export { FormEditStore as default };